import React from 'react';
import { Skeleton } from '@/shared/components/loading/Skeleton';

/**
 * Admin Templates View Skeleton
 */
const AdminTemplatesSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Skeleton className="h-8 w-40 rounded mb-1" />
        <Skeleton className="h-4 w-72 rounded" />
      </div>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="bg-white border border-neutral-200 rounded-xl p-6">
            {/* Template Icon */}
            <div className="flex items-center justify-center w-16 h-16 bg-neutral-100 rounded-xl mb-4">
              <Skeleton className="rounded" />
            </div>

            {/* Template Name */}
            <Skeleton className="h-5 w-32 rounded mb-2" />

            {/* Description */}
            <Skeleton className="h-4 w-full rounded mb-1" />
            <Skeleton className="h-4 w-3/4 rounded mb-4" />

            {/* Tags */}
            <div className="flex gap-2 mb-4">
              <Skeleton className="h-6 w-16 rounded-full" />
              <Skeleton className="h-6 w-20 rounded-full" />
            </div>

            {/* Actions */}
            <div className="flex gap-2">
              <Skeleton className="h-10 flex-1 rounded-lg" />
              <Skeleton className="h-10 w-10 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminTemplatesSkeleton;
